// Vendored from @eduact/ed-components@0.4.10 `TestSummary/EssayAnswer/EssayAnswer`
// (see VENDORED.md for the deltas): a TEXT answer renders as sanitized HTML
// via StudentAnswerHtml; question feedback is direction-stamped; the
// attachment/feedback checks are null-safe. Visuals unchanged.
import { Typography } from '@eduact/ed-system'
import { Text } from '@eduact/ed-components/TestSummary/OrderingAnswer/OrderingAnswer'
import { FeedbacktWrapper } from '@eduact/ed-components/TestSummary/GapAnswer/GapAnswer'
import AnswerAttachments from '@eduact/ed-components/TestSummary/EssayAnswer/AnswerAttachments'
import React, { useRef } from 'react'
import styled from 'styled-components'
import StudentAnswerHtml from '@Components/RichTextAnswer/StudentAnswerHtml'
import stampAutoDir from '@Utilities/StampAutoDir'
import { QuestionContentWrapper } from './QuestionStyled'

type EssayProps = {
	question: any
	test: any
	status: string | undefined
}

const EssayAnswer: React.VoidFunctionComponent<EssayProps> = ({ question }) => {
	const gapRef = useRef<HTMLDivElement>(null)
	const options = question?.answer?.content?.options
	return (
		<QuestionContentWrapper>
			{question.content && <StyledContainer ref={gapRef} dangerouslySetInnerHTML={{ __html: question?.content }} />}
			<AnswersLabel fontSize={{ sm: '0.5rem', lg: '1rem' }} fontFamily="Roboto">
				Answer
			</AnswersLabel>
			{options?.type === 'text' && (
				<Answer>
					<StudentAnswerHtml value={options.answer} />
				</Answer>
			)}
			{options?.type === 'attachment' && <AnswerAttachments answer={options.answer} />}
			{typeof question.feedback === 'string' && question.feedback.trim() !== '' && (
				<>
					<FeebackText>Feedback</FeebackText>
					<FeedbacktWrapper dangerouslySetInnerHTML={{ __html: stampAutoDir(question.feedback) }} />
				</>
			)}
		</QuestionContentWrapper>
	)
}

const FeebackText = styled(Text)`
	margin: 0.563rem;
	@media screen and (min-width: 769px) {
		margin: 2.063rem;
	}
`
const AnswersLabel = styled(Typography)`
	color: ${props => props.theme.colors.silver};
	font-size: 1rem;
	font-weight: 300;
	@media screen and (min-width: 769px) {
		margin-bottom: 0.75rem;
	}
`
const Answer = styled.div`
	font-size: 0.75rem;
	font-weight: 500;
	color: #2f2e41;
	line-height: 1.9;
	letter-spacing: 0.09px;
	margin-bottom: 0.75rem;
	@media screen and (min-width: 769px) {
		font-size: 1.125rem;
		line-height: 1.7;
		letter-spacing: 0.14px;
	}
`
const StyledContainer = styled.div`
	font-size: 0.75rem;
	font-weight: 600;
	color: #2f2e41;
	line-height: 1.9;
	letter-spacing: 0.09px;
	@media screen and (min-width: 769px) {
		font-size: 1.125rem;
		line-height: 1.7;
		letter-spacing: 0.14px;
	}
`
export default EssayAnswer
